angular.module( 'mtic' ).service( 'WindowOpener', function (  ) {
    var windowsArray = [];
    var windowsMap = {};
    var closeListeners = {};
    var closeCallbacks = {};

    var clearListener = function(timerId) {
      if(timerId) {
        window.clearInterval(timerId)
      }
    }

    var setOnClose = function(id) {
      var windowObj = windowsMap[id];
      if(windowObj){
        var timer = window.setInterval(function checkChild() {
          if (windowObj && windowObj.closed) {
            if(closeCallbacks[id]) {
              closeCallbacks[id](true)
            }
            clearListener(timer);
          } else if(!windowObj){
            if(closeCallbacks[id]) {
              closeCallbacks[id](false)
            }
            clearListener(timer);
          }
        }, 500);
        closeListeners[id] = timer;
        return timer;
      }else{
        return null;
      }
    }

    this.open = function(url, id, options) {
        options = options || {};
        options.width = options.width || '500';
        id = id || Math.random().toString(36).substr(2,5);
        var newWindow = window.open(url, '', [
            'width='+options.width
        ].join('&'))
        windowsArray.push({
            id: id,
            window: newWindow
        })
        windowsMap[id] = newWindow;
        setOnClose(id);
        return windowsMap;
    }

    this.close = function(id) {
      var windowObj = windowsMap[id];
      if(windowObj){
        windowObj.close();
      }
    }

    this.getWindow = function(id){
        return windowsMap[id];
    }

    this.getAll = function(){
        return windowsArray;
    }

    this.listenToWindowCloseOf = function(id, cb) {
      closeCallbacks[id] = cb;
      return closeListeners[id];
    }
})
